// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__17Q0g","validationTips":"StatementDescriptor_validationTips__pNLjV"};